var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fulfillment-options-footer"},[(_vm.showStockInfo)?_c('fulfillment-options-stock-info',{attrs:{"stock-subscription-form-enabled":_vm.stockSubscriptionFormEnabled},on:{"change-store":function($event){return _vm.$emit('change-store')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }